<!-- Foreign Languages Catalogs -->
@if (showForeignLanguageCatalogs) {
	@defer {
		<app-foreign-language-catalogs [isPreview]="isPreview" [currentQueryParams]="currentQueryParams" [catalogs]="languageCatalogs" />
	}
}
<!-- Related Catalogs -->
@if (showAdditionalCatalogs) {
	@defer {
		<app-additional-catalogs
			[catalogs]="relatedCatalogs"
			[isPreview]="isPreview"
			[catalogSearchResultModel]="catalogSearchResultModel"
			[currentQueryParams]="currentQueryParams"
			[currentRoutingParams]="currentRoutingParams" />
	}
}
